import {Component, Input, OnInit} from '@angular/core';
import {AppConfigService} from "../../../config/app-config.service";

@Component({
  selector: 'app-metadata-text',
  templateUrl: './metadata-text.component.html',
  styleUrls: ['./metadata-text.component.scss']
})
export class MetadataTextComponent implements OnInit {

  @Input() fullText: string;

  @Input() disableShowMore: false;

  maxText: number;

  showMore = false;

  constructor(private appConfig: AppConfigService) {
  }

  ngOnInit() {
    this.maxText = this.appConfig.showMoreConfig.maxText;
  }

  setShowMore(): void {
    this.showMore = true;
  }

  setShowLess(): void {
    this.showMore = false;
  }

  cutText() {
    return this.fullText.slice(0, this.maxText);
  }
}
